import { CommentStatusEnum } from '../../constants';
import CommentModel from './CommentModel';

class CommentSetAuthorModel {
  id: string;
  displayName: string;

  constructor(data: any = {}) {
    this.id = data?.id;
    this.displayName = data?.displayName;
  }
}

class CommentSetOrganizationModel {
  id: string;
  name: string;

  constructor(data: any = {}) {
    this.id = data?.id;
    this.name = data?.name;
  }
}

export default class CommentSetModel {
  id: string;
  status: string;
  reviewId: string;
  organizationId: string;
  authorId: string;
  late: boolean;
  comments: any[];
  author?: CommentSetAuthorModel;
  organization?: CommentSetOrganizationModel;
  totalCommentSet?: number;
  hasDraft?: boolean;
  responseDraft?: boolean;

  constructor(data: any = {}) {
    this.id = data.id;
    this.status = data.status || CommentStatusEnum.DRAFT;
    this.reviewId = data.reviewId;
    this.organizationId = data.organizationId;
    this.authorId = data.authorId;
    this.late = typeof data.late === 'boolean' ? data.late : false;
    this.comments = (data.comments || []).map(comment => new CommentModel(comment));
    this.totalCommentSet = data.totalCommentSet || 1;
    this.hasDraft = data?.hasDraft;
    this.responseDraft = data?.responseDraft;
    if (data?.author) {
      this.author = new CommentSetAuthorModel(data.author);
    }

    if (data?.organization) {
      this.organization = new CommentSetOrganizationModel(data.organization);
    }
  }
}
